import * as _ from 'lodash';

export type SlottingType = 'all' | 'hashtags';

export function getSlottingFallback(type: SlottingType) {
  const fallback = _.get(fallbacks, type);
  console.log('getSlottingFallback | type', type, fallback);
  return fallback;
}

const fallbacks = {
  all: {
    slots: [
      {
        type: 'SPONSORED_POLL',
      },
      {
        type: 'NEWS',
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'CUSTOM_COMPONENT',
        options: {
          componentType: 'JOB_CAROUSEL',
          limit: 2,
        },
      },
      {
        type: 'COMMUNITY',
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
      },
      {
        options: {},
        type: 'AD_SPEC',
      },
      {
        type: 'COMMUNITY',
      },
      {
        type: 'COMMUNITY',
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
      },
    ],
    adInterval: 10,
  },
  hashtags: {
    slots: [
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
        options: null,
      },
      {
        type: 'COMMUNITY',
        options: null,
      },
      {
        type: 'AD_SPEC',
        options: null,
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
        options: null,
      },
      {
        type: 'COMMUNITY',
        options: null,
      },
      {
        type: 'AD_SPEC',
        options: null,
      },
      {
        type: 'COMMUNITY_RECENT',
      },
      {
        type: 'COMMUNITY',
        options: null,
      },
    ],
  },
  threads: {
    slots: [
      { type: 'COMMUNITY' },
      { type: 'AD_SPEC' },
      { type: 'JOB' },
      { type: 'COMMUNITY' },
      { type: 'AD_SPEC' },
      { type: 'NEWS' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/providers/posts/slotting-fallbacks.ts